export const visit = (vm, at) => {
at({ "pl": { "uiAddonTeams": { "teamSelectLabelOne": "Wybrano 1 zesp\xF3\u0142", "teamSelectLabelMany": "Wybrano zespo\u0142y: {{ count }}", "selectTeams": "Wybierz zespo\u0142y", "selectAll": "Wybierz wszystkie ({{ teamName }})" } } });
};